export const getAllProviders = state =>
    state.primaryShippingProviders.concat(state.secondaryShippingProviders);

export const getAllProducts = state =>
    getAllProviders(state).flatMap(provider => provider.products);

const getAllVariants = state =>
    getAllProducts(state).flatMap(({ variants }) => variants);

export const getPrimaryOrSecondaryProducts = (state, onlyPrimary) =>
    (onlyPrimary
        ? state.primaryShippingProviders
        : state.secondaryShippingProviders
    ).flatMap(provider => provider.products);

export const getSelectedProduct = (state, onlyPrimary) =>
    getPrimaryOrSecondaryProducts(state, onlyPrimary).find(
        ({ selected }) => selected === true
    );

export const getVariant = (state, { type, productId }) =>
    getAllVariants(state).find(
        variant => variant.type === type && variant.id === productId
    );
